import { AddItemButton } from '@core/components/Buttons';
import FormTitle from '@core/components/FormTitle';
import { Divider, Grid, IconButton, Tooltip, makeStyles } from '@material-ui/core';
import InputMonetario from 'app/components/Input/InputMonetario';
import SelectCategoria from 'app/components/Select/SelectCategoria';
import * as Actions from 'app/store/actions';
import { FieldArray } from 'formik';
import React, { Fragment, useState } from 'react';
import { MdHighlightOff, MdSettings } from 'react-icons/md';
import { useDispatch } from 'react-redux';
import PopoverRateioContaReceber from './modal/PopoverRateioContaReceber';

/*
RNE-174 - Limite de inclusão de categoria na conta a pagar : Public <<Functional>> Feature
Created:	14/04/2020 14:49:28
Modified:	30/04/2020 10:17:12
Project:	
Advanced:	
O sistema deve permitir a inclusão de 5 categorias no total.
Quando chegar na quinta linha inserida, o sistema deve apagar o comando "Adicionar categoria".
*/
const exibirAdicionarCategorias = (categorias, disabled, disabledCategoria) => {
  return categorias && categorias.length <= 4 && !disabled && !disabledCategoria;
};

const useStyles = makeStyles({
  divider: {
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
    marginBottom: 16,
  },
  dividerTitle: {
    backgroundColor: '#707070',
    marginBottom: 8,
    opacity: '0.5',
  },
  title: {
    fontSize: 15,
    fontWeight: 500,
  },
  viewMore: {
    color: '#53c4e6',
    textTransform: 'capitalize',
    '&:hover, &:focus': {
      cursor: 'pointer',
    },
  },
});
const ContasReceberCategorias = ({
  values,
  onChange,
  onBlur,
  touched = [],
  errors = [],
  natureza = 'RECEITA',
  disabled,
  disabledCategoria,
  submitCount = 0,
}) => {
  const { categorias } = values;
  const styles = useStyles();

  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElIndex, setAnchorElIndex] = useState(null);
  const dispatch = useDispatch();

  const handleOpenPopover = (event, index) => {
    setAnchorElIndex(index);
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorElIndex(null);
    setAnchorEl(null);
  };

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  return (
    <>
      <Grid item xs={12}>
        <FormTitle title="Categorias" />
      </Grid>

      <FieldArray name="categorias">
        {(arrayHelpers) => {
          const categoriasAdicionadas = categorias?.map((itemCategoria, index) => {
            const touchedIdx = touched.length > index ? touched[index] : undefined;
            const errorIdx = errors.length > index ? errors[index] : undefined;

            const handleSubmit = (rateios) => {
              categorias[index] = Object.assign({ ...categorias[index], rateios: categorias[index].rateios }, rateios);
              showSuccess('Rateio dos centros de custos efetuado com sucesso para a categoria.');
              handleClosePopover();
            };

            const _errors = {
              classe: (touchedIdx?.classe || submitCount > 0) && errorIdx?.classe,
              valorBruto: (touchedIdx?.valorBruto || submitCount > 0) && errorIdx?.valorBruto,
            };
            return (
              <Fragment key={index}>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <p className={styles.title}>{`Categoria ${index + 1}`}</p>
                </Grid>
                <Grid xs={12} item>
                  <Divider className={styles.dividerTitle} />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <SelectCategoria
                    id={`categorias[${index}].classe`}
                    required
                    label="Categoria"
                    value={itemCategoria.classe}
                    onChange={onChange}
                    onBlur={onBlur}
                    maxLength={100}
                    natureza={natureza}
                    touched={!!_errors.classe}
                    error={_errors.classe}
                    disabled={disabled || disabledCategoria}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                  <InputMonetario
                    fullWidth
                    id={`categorias[${index}].valorBruto`}
                    label="Valor (R$)"
                    handleBlur={onBlur}
                    value={itemCategoria?.valorBruto}
                    touched={!!_errors.valorBruto}
                    error={_errors.valorBruto}
                    handleChange={onChange}
                    helperText={_errors.valorBruto}
                    disabled={disabled}
                    required
                    maximumValue="999999999.99"
                  />
                </Grid>
                {/*
                  RNE-149 - Exibição do ícone de exclusão de registros adicionados : Public <<Functional>> Feature
                  Created:	03/04/2020 11:43:19
                  Modified:	03/04/2020 16:27:59
                  Project:	
                  Advanced:	
                  O sistema deve exibir o ícone para excluir categoria, retenção e parcela a partir do segundo registro. O ícone não deve ser exibido para o primeiro registro.
                  */}

                {itemCategoria.classe && (
                  <Grid item style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <Tooltip title="Rateio dos centros de custos" placement="right-end">
                      <IconButton onClick={(event) => handleOpenPopover(event, index)}>
                        <MdSettings size={18} />
                      </IconButton>
                    </Tooltip>

                    <PopoverRateioContaReceber
                      index={index}
                      anchorElIndex={anchorElIndex}
                      anchorEl={anchorEl}
                      onSubmit={handleSubmit}
                      onClose={handleClosePopover}
                      categoria={itemCategoria}
                    />
                  </Grid>
                )}
                {index !== 0 && (
                  <Grid item xs={1} style={{ justifyContent: 'center', alignItems: 'center' }}>
                    <Tooltip title="Excluir categoria" placement="right-end">
                      <IconButton onClick={() => arrayHelpers.remove(index)}>
                        <MdHighlightOff size={18} />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                )}

                <Grid
                  item
                  xs={1}
                  sm={1}
                  md={1}
                  lg={1}
                  xl={1}
                  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                ></Grid>
              </Fragment>
            );
          });
          return (
            <>
              {categoriasAdicionadas}

              {exibirAdicionarCategorias(categorias, disabled, disabledCategoria) && (
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <AddItemButton
                    onClick={() => {
                      arrayHelpers.push({});
                    }}
                  >
                    Adicionar categoria
                  </AddItemButton>
                </Grid>
              )}
            </>
          );
        }}
      </FieldArray>

      <Grid xs={12} item>
        <Divider style={{ background: 'rgba(0,0,0,0.5)' }} />
      </Grid>
    </>
  );
};
export default ContasReceberCategorias;
